import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.css']
})
export class PasswordDialogComponent implements OnInit {

  @Input() inputType: 'text' | 'password' = 'password'; // default is 'password'
  @Input() placeholder: string = 'Enter Console Passcode';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() dialogWidth: string = '';
  value: string = '';

  constructor(protected dialogRef: NbDialogRef<PasswordDialogComponent>) {}

  ngOnInit(): void {
    
  }

  cancel() {
    this.dialogRef.close(null);
  }

  submit() {
    this.dialogRef.close(this.value);
  }

}
